import React, { useEffect, useState, useRef } from 'react';

import './LiveOrdersComponent.css';
import { isMobile } from 'react-device-detect';
import './ImageLoop.css';
import { useNavigate } from 'react-router-dom';
import { Button } from '@mui/material';
import homeback1 from './h10.png'; // adjust path if needed
import './index.css';



import Lottie from 'lottie-react';  // Not { Lottie }
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { FaArrowRight, FaArrowLeft } from 'react-icons/fa';
import usersAnimation from './users.json';
import { Info as InfoIcon } from '@mui/icons-material'; // Make sure this is imported

// =====================
// Industry thumbnails
// =====================
import t1 from './t1.png';
import t2 from './t2.png';
import t3 from './t3.png';

// =====================
// Restaurant Feature Images
// =====================
import coffee1 from './coffee1.png';
import coffee2 from './coffee2.png';
import coffee3 from './coffee3.png';
import coffee4 from './coffee4.png';
import RestaurantIcon from '@mui/icons-material/Restaurant';
import SelfImprovementIcon from '@mui/icons-material/FitnessCenter'; // yoga


import ContentCutIcon from '@mui/icons-material/ContentCut'; // scissors


// =====================
// Barber Feature Images
// =====================
import cuts1 from './cuts1.png';
import cuts2 from './cuts2.png';
import cuts3 from './cuts3.png';
import cuts4 from './cuts4.png';

// =====================
// Gym Feature Images
// =====================
import core1 from './core1.png';
import core2 from './core2.png';
import core3 from './core3.png';
import core4 from './core4.png';

// =====================
// Orders Section Images
// =====================
import LiveOrders from './cCafe5.png';
import LiveOrdersMob from './mobileOrders.png';
import BarberOrders from './webCuts.png';
import BarberOrdersMob from './mobileCuts.png';
import GymOrders from './webCore.png';
import GymOrdersMob from './mobileCore.png';

// =====================
// Stats Section Images
// =====================


// =====================
// Loop Images for Restaurants
// =====================
import cafe1 from './assets/cafePics/a1.png';
import cafe2 from './assets/cafePics/a2.png';
import cafe3 from './assets/cafePics/a3.png';
import cafe4 from './assets/cafePics/a4.png';
import cafe5 from './assets/cafePics/a5.png';
import cafe6 from './assets/cafePics/a6.png';
import cafe7 from './assets/cafePics/a7.png';
import cafe8 from './assets/cafePics/a8.png';
import cafe9 from './assets/cafePics/a9.png';
import cafe10 from './assets/cafePics/a10.png';
import cafe11 from './assets/cafePics/a11.png';
import cafe12 from './assets/cafePics/a12.png';
import cafe13 from './assets/cafePics/a13.png';
import cafe14 from './assets/cafePics/a14.png';

// =====================
// Loop Images for Barbers
// =====================
import cutsL1 from './assets/cutsPics/a1.png';
import cutsL2 from './assets/cutsPics/a2.png';
import cutsL3 from './assets/cutsPics/a3.png';
import cutsL4 from './assets/cutsPics/a4.png';
import cutsL5 from './assets/cutsPics/a5.png';
import cutsL6 from './assets/cutsPics/a6.png';
import cutsL7 from './assets/cutsPics/a7.png';
import cutsL8 from './assets/cutsPics/a8.png';
import cutsL9 from './assets/cutsPics/a9.png';
import cutsL10 from './assets/cutsPics/a10.png';
import cutsL11 from './assets/cutsPics/a11.png';
import cutsL12 from './assets/cutsPics/a12.png';
import cutsL13 from './assets/cutsPics/a13.png';
import cutsL14 from './assets/cutsPics/a14.png';

// =====================
// Loop Images for Gyms
// =====================
import coreL1 from './assets/corePics/a1.png';
import coreL2 from './assets/corePics/a2.png';
import coreL3 from './assets/corePics/a3.png';
import coreL4 from './assets/corePics/a4.png';
import coreL5 from './assets/corePics/a5.png';
import coreL6 from './assets/corePics/a6.png';
import coreL7 from './assets/corePics/a7.png';
import coreL8 from './assets/corePics/a8.png';
import coreL9 from './assets/corePics/a9.png';
import coreL10 from './assets/corePics/a10.png';
import coreL11 from './assets/corePics/a11.png';
import coreL12 from './assets/corePics/a12.png';
import coreL13 from './assets/corePics/a13.png';
import coreL14 from './assets/corePics/a14.png';

// =====================
// Arrays of loop images
// =====================
const cafeLoopImages = [
  cafe1, cafe2, cafe3, cafe4, cafe5, cafe6, cafe7,
  cafe8, cafe9, cafe10, cafe11, cafe12, cafe13, cafe14
];
const cutsLoopImages = [
  cutsL1, cutsL2, cutsL3, cutsL4, cutsL5, cutsL6, cutsL7,
  cutsL8, cutsL9, cutsL10, cutsL11, cutsL12, cutsL13, cutsL14
];
const coreLoopImages = [
  coreL1, coreL2, coreL3, coreL4, coreL5, coreL6, coreL7,
  coreL8, coreL9, coreL10, coreL11, coreL12, coreL13, coreL14
];

// =====================
// Orders Section Data
// =====================
const ordersData = {
  'Restaurants': {
    title: "Process orders in real time",
    text: `Your application comes with our all-in-one web client portal, where you will be able to handle orders as they come in. We will provide your restaurants with all the required equipment to access this portal!`,
    imgWeb: LiveOrders,
    imgMobile: LiveOrdersMob
  },
  'Barbers / Salons': {
    title: "Manage bookings and revenue",
    text: `Your application comes with our all-in-one dashboard to keep appointments organized. It includes built-in payroll and bookkeeping tools so your team stays focused on customers.`,
    imgWeb: BarberOrders,
    imgMobile: BarberOrdersMob
  },
  'Gyms / Studios': {
    title: "Manage classes and revenue",
    text: `Your application comes with our all-in-one dashboard to add classes, manage memberships, and stay organized. It includes built-in payroll and bookkeeping tools so your team stays focused on customers.`,
    imgWeb: GymOrders,
    imgMobile: GymOrdersMob
  }
  
};



// =====================
// Stats Section Data
// =====================

const clientsData = {
  'Restaurants': {
    text: `Already take orders on your website or use a rewards program? We can import your clients into the app, allowing them to claim their accounts seamlessly.`
  },
  'Barbers / Salons': {
    text: `Already track client haircut preferences or run a rewards program on your website? We'll transfer all that data into the app so customers can claim their profiles with ease.`
  },
  'Gyms / Studios': {
    text: `Already handle class sign-ups on a website or use a larger app? We’ll transfer your members and classes, allowing users to claim their accounts instantly.`
  }
};



const statsData = {
  'Restaurants': {
    title: "The rise of mobile applications for restaurants",
    paragraph: `In the last few years, restaurants have seen a huge boom in mobile apps. A key factor is <span class="highlightNumberTop">customer loyalty.</span> Research shows that <span class="highlightNumberTop">78%</span> of customers say they’re more likely to visit a restaurant where they can earn points through loyalty programs.`,
    cards: [
      {
        emoji: '🔔',
        text: `Having an app lets you send push notifications to users, which are better than ads because they show up right on the user's lock screen and <span class="highlightNumber">cost you nothing!</span>`
      },
      {
        emoji: '🎁',
        text: `Offering loyalty points encourages customers to add more items to orders when redeeming rewards, generating additional sales.`
      },
      {
        emoji: '📈',
        text: `Providing mobile ordering reduces checkout lines. The less crowded environment motivates more customers to visit, which boosts <span class="highlightNumber">overall sales volume.</span>`
      }
    ]
  },
  'Barbers / Salons': {
    title: "Mobile apps are revolutionizing barbershops and salons",
    paragraph: `Branded apps are becoming increasingly more popular across the industry as a way to <span class="highlightNumberTop">increase brand loyalty</span> and <span class="highlightNumberTop">boost revenue.</span> From appointment scheduling to automated reminders, they make things easier for clients and help owners operate more efficiently.`,
    cards: [
      {
        emoji: '🔔',
        text: `Having an app lets you send push notifications to users, which are better than ads because they show up right on the user's lock screen and <span class="highlightNumber">cost you nothing!</span>`
      },
      {
        emoji: '🎁',
        text: `Loyalty features like punch cards for haircuts encourage repeat visits and referrals, turning happy clients into promoters.`
      },
      {
        emoji: '📈',
        text: `Displaying the current wait time <span class="highlightNumber">drives more walk-ins.</span> With just a few taps, customers can see if they can get in now without calling.`
      }
    ]
    
      
    
  },
  
  'Gyms / Studios': {
    title: "Mobile apps are revolutionizing gyms and studios",
    paragraph: `Branded apps are becoming increasingly more popular across the industry as a way to <span class="highlightNumberTop">increase brand loyalty</span> and <span class="highlightNumberTop">boost revenue.</span> From class scheduling to automated reminders, they make things easier for clients and help owners operate more efficiently.`,
    cards: [
      {
        emoji: '🔔',
        text: `Having an app lets you send push notifications to users, which are better than ads because they show up right on the user's lock screen and <span class="highlightNumber">cost you nothing!</span>`
      },
      {
        emoji: '📈',
        text: `Offering discounts for upcoming series results in higher sales through an app, since most users have a card saved and can purchase it in just a few clicks.`
      },
      {
        emoji: '🧘🏾‍♀️',
        text: `Offering a joinable waitlist increases the chances of <span class="highlightNumber">keeping classes full.</span> When someone cancels, the first person on the list is automatically added.`
      }
    ]
    
    
  }
  
};



// =====================
// Custom Slider Arrows
// =====================
const NextArrow = ({ onClick }) => (
  <div
    className="custom-arrow next"
    onClick={onClick}
    style={{
      display: 'block',
      position: 'absolute',
      right: '10px',
      top: '50%',
      transform: 'translateY(-50%)',
      zIndex: 1,
      cursor: 'pointer'
    }}
  >
    <FaArrowRight size={30} color="fff" />
  </div>
);

const PrevArrow = ({ onClick }) => (
  <div
    className="custom-arrow prev"
    onClick={onClick}
    style={{
      display: 'block',
      position: 'absolute',
      left: '10px',
      top: '50%',
      transform: 'translateY(-50%)',
      zIndex: 1,
      cursor: 'pointer'
    }}
  >
    <FaArrowLeft size={30} color="#fff" />
  </div>
);

// =====================
// Home Component
// =====================
const Home = () => {
   useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
  
    // Check URL for category param and map to index/label
    const params = new URLSearchParams(window.location.search);
    const category = params.get("category");
  
    if (category) {
      let indexToSet = 0;
      let industryLabel = 'Restaurants';
  
      if (category.toLowerCase() === 'fitness') {
        indexToSet = 1;
        industryLabel = 'Gyms / Studios';
      } else if (category.toLowerCase() === 'bookings') {
        indexToSet = 2;
        industryLabel = 'Barbers / Salons';
      }
  
      setSelectedIndex(indexToSet);
      setSelected(industryLabel);
      if (sliderRef.current) sliderRef.current.slickGoTo(0);
    }
  
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const [selectedIndex, setSelectedIndex] = useState(0);
  const navigate = useNavigate();
  const scrollRef = useRef(null);

  const handleRegisterClick = () => {
    window.scrollTo(0, 0);
    navigate('/contact');
  };

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
 
  

  const sliderSettings = {
    dots: true,
    arrows: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    centerMode: windowWidth < 1050,
    centerPadding: '0px'
  };

  const [selected, setSelected] = useState('Restaurants');
  const sliderRef = useRef(null);

  const industryFeatures = {
    'Restaurants': {
      images: [coffee1, coffee2, coffee3, coffee4],
      titles: ['Mobile Orders', 'Reward Programs', 'Order Tracking', 'Item Customization']
    },
    'Barbers / Salons': {
      images: [cuts1, cuts2, cuts3, cuts4],
      titles: ['Walk Ins', 'Book Appointments', 'Reward Programs', 'List Services']
    },
    'Gyms / Studios': {
      images: [core1, core2, core3, core4],
      titles: ['Book Classes', 'Make Announcements', 'Trainer Training', 'Memberships']
    }
  };

  const { images: imagesToDisplay, titles: titlesToDisplay } =
    industryFeatures[selected] || industryFeatures['Restaurants'];

  const industries = [
    { name: 'Restaurants', image: t1 },
    { name: 'Gyms / Studios', image: t2 },
    { name: 'Barbers / Salons', image: t3 },
  ];

  const getLoopImages = () => {
    if (selected === 'Restaurants') return cafeLoopImages;
    if (selected === 'Barbers / Salons') return cutsLoopImages;
    return coreLoopImages;
  };

  // Duplicate images for infinite scroll effect
  const loopImages = getLoopImages();
  const infiniteImages1 = [...loopImages, ...loopImages, ...loopImages, ...loopImages, ...loopImages];
  const infiniteImages2 = [...loopImages, ...loopImages, ...loopImages, ...loopImages, ...loopImages];

  const getCircleStyle = (industryName) => ({
    width: 'clamp(50px, 22vw, 100px)',
    height: 'clamp(50px, 22vw, 100px)',
    borderRadius: '50%',
    backgroundColor: selected === industryName ? '#86bbd8' : 'white',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'hidden',
    transition: '0.2s'
  });

  const getImageStyle = () => ({
    width: '75%',
    height: '75%',
    objectFit: 'contain',
    mixBlendMode: 'multiply'
  });

  const scrollToFeatures = () => {
    if (isMobile && scrollRef.current) {
      const yOffset = 0;
      const y = scrollRef.current.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  };

  const getOrdersImage = () => {
    const data = ordersData[selected] || ordersData['Restaurants'];
    return isMobile ? data.imgMobile : data.imgWeb;
  };

  const buttonOptions = [
    { label: 'Resturants' },
    { label: 'Fitness' },
    { label: '' },
  ];

  const backgroundImage = require(`./homeback${selectedIndex + 1}.png`);

  return (
    <div className="mainContainer">
      {/* Header Section */}




      <div
        className="homeContainer"
        style={{
          position: 'relative',
          width: '100%',
          backgroundImage: `url(${homeback1})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          overflow: 'hidden',
          paddingBottom: '0px',
        }}
      >



        {/* <div
        className="homeContainer"
        style={{
          position: 'relative',
          width: '100%',
          backgroundColor: 'black',
          overflow: 'hidden',
          paddingBottom: '0px',
        }}
      >
        {/* Ripple Background */}
        {/* <div
          style={{
            position: 'absolute',
            inset: 0,
            zIndex: 0,
            pointerEvents: 'none',
          }}
        >
          <RippleGrid
            gridColor="#86BBD8"
            rippleIntensity={0.05}
            gridSize={10}
            gridThickness={15}
            fadeDistance={1.5}
            vignetteStrength={2}
            glowIntensity={0.1}
            opacity={1}
            gridRotation={0}
            mouseInteraction={true}
            mouseInteractionRadius={0.8}
            enableRainbow={false}
          />
        </div>  */}

        {/* Foreground Content */}
        <div style={{ position: 'relative', zIndex: 1 }}>
          <div
            className="centeredHeader"
            style={{
              paddingBottom: '20px', // ✅ This ensures room even with overflow
            }}
          >
            <div >
              <p className="headerLabel">Launch a custom mobile app for your business!</p>


            </div>
            <p className="headerLabel2">Select your industry</p>
            <div
              style={{
                display: 'flex',
                width: '90%',
                margin: '16px auto 0 auto',
                borderRadius: '30px',
                overflow: 'hidden',
                marginBottom: '0px',
                marginTop: '0px',
                maxWidth: '555px',
                backgroundColor: ' rgba(0, 0, 0, 0.9)'

              }}
            >
              {[0, 1, 2].map((index) => {
                const isSelected = index === selectedIndex;
                const bgColor = isSelected ? '#86BBD8' : '#ffffff';
                const textColor = isSelected ? 'white' : '#336699';
                const iconColor = isSelected ? 'white' : '#336699';
                const borderStyle = '.5px solid #336699';

                let label = '';
                let Icon = null;
                let industryName = '';

                if (index === 0) {
                 
                  Icon = RestaurantIcon;
                  industryName = 'Restaurants';
                } else if (index === 1) {
          
                  Icon = SelfImprovementIcon;
                  industryName = 'Gyms / Studios';
                } else {

                  Icon = ContentCutIcon;
                  industryName = 'Barbers / Salons';
                }

                return (
                  <button
                    key={index}
                    onClick={() => {
                      setSelectedIndex(index);
                      setSelected(industryName);
                      if (sliderRef.current) {
                        sliderRef.current.slickGoTo(0);
                        // setTimeout(() => sliderRef.current.slickGoTo(1), 500);
                      }
                      // scrollToFeatures();
                    }}
                    style={{
                      backgroundColor: bgColor,
                      color: textColor,
                      border: borderStyle,
                      width: '33.33%',
                      height: '55px',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: '14px',
                      fontWeight: 'bold',
                      cursor: 'pointer',
                      padding: 0,
                      gap: '2px',
                      transition: 'background-color 0.2s, color 0.2s',
                      borderRadius: 0,
                    }}
                  >
                    <Icon style={{ color: iconColor, fontSize: '35px' }} />
                  </button>
                );
              })}
            </div>

            {/* ✅ Spacer div to ensure visual space */}

          </div>



          {/* Feature Section */}
          <div ref={scrollRef}>
            {windowWidth < 1050 ? (
              <Slider key={windowWidth < 1050 ? 'mobile' : 'desktop'} ref={sliderRef} {...sliderSettings}>
                {imagesToDisplay.map((imageSrc, index) => (
                  <div key={index} className="imageWrapper">

                    <img
                      src={imageSrc}
                      alt={`Feature ${index + 1}`}
                      className="exampleImage"
                      style={{ display: 'block', margin: '0 auto', marginBottom: '5px' }}
                    />
                    <p className="imageDescription">{titlesToDisplay[index]}</p>
                  </div>
                ))}
              </Slider>
            ) : (
              <div className="imageContainer">
                {imagesToDisplay.map((imageSrc, index) => (
                  <div key={index} className="imageWrapper">
                    <div className="topDesc">
                      <p className="imageDescription">{titlesToDisplay[index]}</p>
                    </div>
                    <img
                      src={imageSrc}
                      alt={`Feature ${index + 1}`}
                      className="exampleImage"
                    />
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>



      {/* Orders Section */}
      <div>
        <div className="salesTextPort">
          <div className="salesTextTop2">
            <h2 className="salesTitle">{ordersData[selected].title}</h2>
            <p className="salesParagraph">{ordersData[selected].text}</p>
          </div>
        </div>
        <img className="centeredImage" src={getOrdersImage()} alt="Orders" />
      </div>

      {/* Looping Images */}
      <div className="titleText">
        <div className="salesTextPort" style={{ backgroundColor: 'transparent' }}>
          <div className="salesTextTop2">
            <h2 className="salesTitle">Choose from a wide range of already available features!</h2>
          </div>
        </div>
      </div>
      <div className="image-row">
        {infiniteImages1.map((img, index) => (
          <div key={index} className="image-wrapper">
            <img
              src={img}
              alt={`Image ${index}`}
              className="loop-image"
            />
          </div>
        ))}
      </div>

      <div className="salesTextPort">
        <div className="salesTextTop2">
          <h2 className="salesTitle">Easily integrate with your current CRM</h2>
          <p className="salesParagraph">{clientsData[selected].text}</p>
        </div>
      </div>


      <Lottie
        animationData={usersAnimation}
        loop={true} // Set to true to loop the animation
        className="usersLottie"
      />



      {/* Stats Section */}
      {/* Stats Section */}
      <div className="salesText">
        <div className="salesTextTop">
          <h2 className="salesTitle">{statsData[selected].title}</h2>
          <p
            className="salesParagraph"
            dangerouslySetInnerHTML={{ __html: statsData[selected].paragraph }}
          />
        </div>
        <div className="salesTextBottom">
          {statsData[selected].cards.map((card, index) => (
            <div key={index} className="blueRectangle">
              <div className="rectangleContent">
                <div
                  className="rectangleEmoji"
                  style={{ fontSize: '50px', marginRight: '12px' }}
                  aria-label={`Emoji for Card ${index}`}
                >
                  {card.emoji}
                </div>
                <p
                  className="rectangleText"
                  dangerouslySetInnerHTML={{ __html: card.text }}
                />
              </div>
            </div>
          ))}
        </div>
      </div>


      {/* Footer CTA */}
      <div style={{ textAlign: 'center', width: '100%', marginTop: '0px', marginBottom: '75px' }}>
        <p className="text-rectangle2">
          Interested in learning more about what we can do for your business?
        </p>
        <Button
          variant="contained"
          onClick={handleRegisterClick}
          style={{
            marginTop: '0px',
            fontFamily: 'Medium',
            fontSize: '1.25rem',
            marginLeft: '5%',
            marginRight: '5%',
            backgroundColor: '#86BBD8',
            color: '#fff'
          }}
        >
          Book a free consultation
        </Button>
      </div>
    </div>
  );
};

export default Home;
